// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const AddressWrapper = styled.address`
 font-style: normal;
 padding-top: 1em;
 
  > span {
    display: block;
  }
`

export const CompaniesWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: .5em;
  flex: 1; 
  overflow: auto;
  margin-top: 1em;
  max-height: 400px;
  min-height: 200px;
  padding: .5em 1em;
  
  > .company-info {
    border-top: thin solid;
    
    &:first-child {
      border-top: 0;
    }
  }
`

export const InfoItemWrapper = styled.div`
  display: flex; 
  margin: .5em 0;
  
  > :first-child {
    max-width: 40%;
    min-width: 40%;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-height: 80vh;
`

export const StatusIcon = styled.p`
  // default background value to red
  // $red: #d02f3c; in SCSS
  // $green: $46b34e in SCSS
  background-color: ${({ active }) => active ? '#46b34e' : '#d02f3c'};
  border-radius: 50%;
  display: inline-block;
  height: 1em;
  overflow: hidden;
  width: 1em;
`
